import { Icon } from "@iconify/react";
import { Button } from "primereact/button";
import React from "react";
import { useTranslation } from "react-i18next";
import { capitalizeWord, formatDateV2 } from "../../../../Utils";

const RequestAbsenceComponent = ({ notification, deleteNotification, markAsRead }) => {
    const { t, i18n } = useTranslation();
    return (
        <div className="card grid p-2" style={{ borderRadius: "var(--border-radius)" }}>
            <div className="col-1">
                {/* <Avatar
                    image={notification?.avatar}
                    label={!notification?.avatar ? `${notification?.author?.split(" ")[0]?.split("")[0]}${notification?.author?.split(" ")[1]?.split("")[0]}` : null}
                    style={!notification?.avatar ? { backgroundColor: "var(--surface-300)", color: "var(--secondary-color-extra-light)" } : null}
                    shape="circle"
                    size="xlarge"
                /> */}
                <div className="border-round h-5rem w-5rem" style={{ border: "1px solid #e0e0e0" }}>
                    <div className="flex flex-column ">
                        <div className="flex align-items-center align-content-center justify-content-center pt-1">
                            <label className="mousee-text font-large font-weight-semibold">{notification?.data?.day}</label>
                        </div>
                        <div className="flex align-items-center align-content-end justify-content-center mt-1" style={{ borderTop: "1px solid #e0e0e0" }}>
                            <label className="mousee-text font-small font-weight-regular">{capitalizeWord(new Date(new Date().getFullYear(), parseInt(notification?.data?.month), 1).toLocaleString(i18n?.language, { month: "short" }))}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-10">
                <div className="grid">
                    <div className="col-12 pb-0">
                        <div className="grid pb-0">
                            <div className="col-12 pb-0 pt-2">
                                <label className="mousee-text font-x-small font-weight-semibold">{notification?.data?.absence_name}</label>
                            </div>
                            <div className="col-12 pb-0 pt-0">
                                <label className="mousee-text font-x-small font-weight-semibold">{notification?.data?.all_day ? t("label.all_day") : t("label.half_day")}</label>
                            </div>
                            <div className="col-12 pb-0 pt-1">
                                <label className="mousee-text font-x-small font-weight-regular">{t("label.You_ve_got_a_new_request_from_username", { username: notification?.author })}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-1">
                <label className="mousee-text-small font-xx-small font-weight-regular">{formatDateV2(notification?.created_at, false, i18n.language)}</label>
            </div>

            <div className="col-12">
                <div className="flex justify-content-between flex-wrap">
                    <div className="flex align-items-start justify-content-left">
                        <Button
                            label={t("label.go_to_absences")}
                            className="p-button-link pl-0"
                            onClick={(e) => {
                                window.open(notification?.url, "_blank", "noopener,noreferrer");
                            }}
                        />
                    </div>
                    <div className="flex align-items-center justify-content-center">
                        <div className="flex justify-content-end align-content-center flex-wrap">
                            <div className="flex align-items-center justify-content-center">
                                {notification?.readed === "false" ? <Button label={t("label.single_mark_as_read")} className="p-button-link" onClick={markAsRead} /> : <label className="mousee-text-small font-x-small font-weight-regular pr-3">{t("label.readed")}</label>}
                            </div>
                            <div className="flex align-items-center justify-content-center">
                                <Button icon={<Icon icon="ph:trash-light" className="" style={{ fontSize: "20px" }} />} className="p-button-text p-button-secondary" onClick={deleteNotification} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default RequestAbsenceComponent;
